import { combineReducers } from '@reduxjs/toolkit'
import auth from './auth'
import content from './content'
import mediaHub from './mediaHub'
import notices from './notices'
import recentProducts from './recentProducts'
import shop from './shop'
import site from './site'

export default combineReducers({ auth, content, mediaHub, notices, recentProducts, shop, site })
